const urlReg = /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
const businessEmailReg = /^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(?!hotmail|gmail|yahoo)(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(]?)$/
const textReg = /^[\u0620-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDCF\uFDF0-\uFDFF\uFE70-\uFEFFa-zA-Z ]*$/
const companyReg = /^[\u0620-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDCF\uFDF0-\uFDFF\uFE70-\uFEFFa-zA-Z0-9]/
const personalEmailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
//const passwordReg = /^(?=.*[\d])(?=.*[A-Za-z])(?=.*[!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>, .])[\w!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>, .]{8,}$/
const passwordReg = /[^ ]{8,}$/
const numberReg = /^\d*$/
const phoneNumReg = /^[+]*[(]?[0-9]{1,4}[)]?[-\s\./0-9]*$/
const descriptionReg = /[^ ]/
const nicknameReg = /^[a-zA-Z0-9_][a-zA-Z0-9_.]*$/
const moneyReg = /^\$?\d+(,\d{3})*(\.\d*)?$/
export {
  urlReg,
  businessEmailReg,
  textReg,
  companyReg,
  personalEmailReg,
  passwordReg,
  numberReg,
  phoneNumReg,
  descriptionReg,
  nicknameReg,
  moneyReg,
}
